<route>
    {
      "meta": {
        "requireAdmin": true,
        "customSite": true
      }
    }
</route>
<template>
  <div>
    <section class=" text-center font-semibold">
      <h2 class="text-2xl">Implicit Subscription</h2>
      <p><span class="text-white bg-orange-400 rounded-sm p-1 mr-2">Testing mode:</span>Only Admin can use it do not enter real card values while doing payment.</p>
    </section>
    <section>
        <stripe-pricing-table
      pricing-table-id="prctbl_1MNA83SJEMXpT7Db4s00yFP7"
      publishable-key="pk_test_51MMsyiSJEMXpT7DbE1UI4h5kmeREJqD3oIATJs6JeUU8dCjvT66ETTnq9w1OFanBHRn1HEskJVtp4SOXWOi0ON1R00TsaXSoK5"
    >
    </stripe-pricing-table>
    </section>
  </div>
</template>

<script>
export default {
  name: 'subscription',
  layout: 'admin',
  order: 1,
};
</script>
